module.exports = __webpack_public_path__ + "static/media/YF98_5.3b87f1d8.jpg";